import { Table, Tabs, Typography } from "antd";
import classes from "./AppDashboard.module.scss";
import useStripeDashboard from "./useStripeDashboardhook";

const { Title } = Typography;

const TabContent = ({ schemaName, rows, columns }) => {
  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
        {schemaName}
      </Title>
      <div className={classes.tableContainer}>
        <Table dataSource={rows} columns={columns} />
      </div>
    </>
  );
};

const StripeDashboard = () => {
  const {
    customerColumns,
    customerData,
    chargesColumns,
    chargesData,
    productColumns,
    productData,
    pricesColumns,
    pricesData,
    invoiceColumns,
    invoiceData,
  } = useStripeDashboard();

  const tabItems = [
    {
      id: Math.random(),
      label: "Customers",
      key: "customers",
      children: (
        <TabContent
          schemaName={"List of Customers"}
          rows={customerData}
          columns={customerColumns}
        />
      ),
    },
    {
      id: Math.random(),
      label: "Charges",
      key: "charges",
      children: (
        <TabContent
          schemaName={"List of Charges"}
          rows={chargesData}
          columns={chargesColumns}
        />
      ),
    },
    {
      id: Math.random(),
      label: "Products",
      key: "products",
      children: (
        <TabContent
          schemaName={"List of Products"}
          rows={productData}
          columns={productColumns}
        />
      ),
    },
    {
      id: Math.random(),
      label: "Pricing",
      key: "pricing",
      children: (
        <TabContent
          schemaName={"List of Pricing"}
          rows={pricesData}
          columns={pricesColumns}
        />
      ),
    },
    {
      id: Math.random(),
      label: "Invoices",
      key: "invoices",
      children: (
        <TabContent
          schemaName={"List of Invoices"}
          rows={invoiceData}
          columns={invoiceColumns}
        />
      ),
    },
  ];
  return (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
          Stripe Dashboard
        </Title>
      </div>
      <div className={classes.tabContainer}>
        <Tabs
          style={{ height: "100%" }}
          tabPosition={"left"}
          items={tabItems}
        />
      </div>
    </>
  );
};
export default StripeDashboard;
